module.exports = __webpack_public_path__ + "img/info_6.19e9237a.jpeg";